import { configureStore } from '@reduxjs/toolkit';

import { rtkQueryErrorLogger } from 'middlewares/error.middleware';

import alphaPod from 'store/alpha';
import authorization from 'store/authorization';
import callScribe from 'store/callScribe';
import clientPortalChats from 'store/clientPortalChats';
import common from 'store/common';
import configuration from 'store/configuration';
import connectwise from 'store/connectwise';
import microsoft from 'store/microsoft';
import oneClickEuvMethods from 'store/oneClickEuvMethods';
import pod from 'store/pod';
import podFeatures from 'store/podFeatures';
import pricePlan from 'store/pricePlan';
import scheduleAssistAccess from 'store/scheduleAssistAccess';
import secureDataSharing from 'store/secureDataSharing';
import smsConversations from 'store/smsConversations';
import whatsAppMessaging from 'store/whatsAppMessaging';
import table from 'store/table';
import teamsChat from 'store/teamsChat';
import templates from 'store/templates';
import user from 'store/user';
import verificationSettings from 'store/verificationSettings';

export const store = configureStore({
  reducer: {
    configuration,
    user,
    authorization,
    common,
    verificationSettings,
    oneClickEuvMethods,
    pod,
    clientPortalChats,
    smsConversations,
    whatsAppMessaging,
    secureDataSharing,
    scheduleAssistAccess,
    podFeatures,
    table,
    pricePlan,
    connectwise,
    templates,
    teamsChat,
    microsoft,
    alphaPod,
    callScribe,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(rtkQueryErrorLogger),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
